import { render, staticRenderFns } from "./customizedManagement.vue?vue&type=template&id=5fc83782&scoped=true"
import script from "./customizedManagement.vue?vue&type=script&lang=js"
export * from "./customizedManagement.vue?vue&type=script&lang=js"
import style0 from "./customizedManagement.vue?vue&type=style&index=0&id=5fc83782&prod&lang=scss&scoped=true"
import style1 from "./customizedManagement.vue?vue&type=style&index=1&id=5fc83782&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc83782",
  null
  
)

export default component.exports